import { FileKind } from "../../../define/FileKind";
import { BaseLocalDataInfos } from "../base/BaseLocalData";


export default class MansionData extends BaseLocalDataInfos {

    /** 容量 */
    curCapacity: number = 0;
    /** 每天消耗金币 */
    costGold: number = 0;
    /** 当前卡牌列表 */
    cardList: number[] = [];
    /** 已使用的卡牌 */
    useCardList: boolean[] = [];
    /** 最后点击黑影的时间 */
    lastBlackShadowTime: string = '';
    /** 最后卡牌刷新时间 */
    lastCardRefreshTime: string = '';

    getLocalDataKey() {
        return FileKind.SaveLocalDataKey.MANSION_DATA;
    }
   
}
